<template>
  <div>
    <el-container class="left">
      <el-aside width="200px" class="left">
        <el-menu @select="view" :default-active="tmplCode" class="f-h">
          <el-menu-item :index="code" v-for="code in tmplCodes" :key="code">
            <i class="el-icon-tickets"></i>
            <span slot="title">{{ code | dictText("MrTemplate") }}</span>
          </el-menu-item>
          <el-menu-item v-if="settingForSimple" :index="API_SIMPLE" key="api_simple">
            <i class="el-icon-tickets"></i>
            {{ API_SIMPLE }}
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main :style="{ padding: '0px', 'max-height': maxHeight }">
        <div style="padding: 0 1rem; min-height: 10rem">
          <h3 v-if="!hideHeader && main">{{ tmplCode | dictText("MrTemplate") }}<label class="pull-right" @click="showStruct = true">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label></h3>
          <el-link v-if="pdf" type="primary" icon="el-icon-download" :href="pdf" target="_blank">{{ pdf }}</el-link>
          <el-descriptions v-if="!hideHeader && main">
            <el-descriptions-item label="患者">{{ main.patientName }}</el-descriptions-item>
            <el-descriptions-item label="性别">{{ main.patientGender | dictText("Gender") }}</el-descriptions-item>
            <el-descriptions-item label="年龄">{{ main.patientAge }}</el-descriptions-item>
            <el-descriptions-item label="医生">{{ main.doctorName }}</el-descriptions-item>
            <el-descriptions-item label="科室">{{ main.deptCode | dictText("Dept") }}</el-descriptions-item>
            <el-descriptions-item label="日期">{{ main.opTime | fmtDate }}</el-descriptions-item>
          </el-descriptions>
          <el-skeleton v-if="loading || formatStr == '加载中...'" :rows="6" animated style="padding: 1rem" />
          <el-empty v-else-if="errStr" :description="errStr" />
          <pre v-else style="text-align: left; font-size: 14px; white-space: pre-wrap; word-wrap: break-word">
           {{ "\r\n" + formatStr }}
          </pre>
        </div>
      </el-main>
      <el-drawer title="元数据" :visible.sync="showStruct" direction="rtl" append-to-body :modal="false">
        <div style="padding: 0.5rem">
          <pre class="fmt">{{ orgnizeData }}</pre>
          <el-divider />
          <pre class="fmt">{{ struct }}</pre>
        </div>
      </el-drawer>
    </el-container>
  </div>
</template>
<script>
  import { apiFuns } from "sw-hic";
  import { orgnize, format } from "../common/structData";
  let api = {
    MrMain: {
      ...apiFuns.genStandard("main", "/api/emr", true),
      pdf: (id) => apiFuns.get(`/api/emr/main/${id}/pdf`),
    },
    Mr: apiFuns.genStandard("mr", "/api/emr", true),
    Struct: {
      query: (tmplCode, mrId, dbVerId) => apiFuns.get(dbVerId ? `/api/emr/structureData/${tmplCode}/${mrId}/${dbVerId}` : `/api/emr/structureData/${tmplCode}/${mrId}/%20`),
    },
    Setting: apiFuns.genStandard("setting", "/api/md", true),
  };
  // 为了调用 his 接口，封装 axios 的 get 请求
  function swGet(url, para, setting) {
    console.log(url);
    return new Promise((resolve, reject) => {
      apiFuns.axios
        .get(url, para)
        .then((response) => {
          if (response.data[setting.code ? setting.code : 'code'] == (setting.codeSuccess == null ? 1 : setting.codeSuccess)) {
            resolve(response.data[setting.data ? setting.data : 'data']);
          } else {
            reject(response.data[setting.desc ? setting.desc : 'desc']);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  export default {
    name: "hic-emr-info-panel",
    props: {
      opNo: String,
      hideHeader: Boolean,
      maxHeight: String,
    },
    data() {
      return {
        loading: false,
        errMsg: null,
        main: null,
        mrs: [],
        fmtStructs: {},
        originStructs: {},
        tmplCode: null,
        showStruct: false,
        settingForSimple: null,
        settingViewDataPriority: null,
        API_SIMPLE: "简易病历",
        pdfs: [],
      };
    },
    computed: {
      formatStr() {
        return this.fmtStructs[this.tmplCode] ?? "";
      },
      errStr() {
        return this.errMsg || (this.formatStr.startsWith("调阅失败") ? this.formatStr.substring(5) : null);
      },
      struct() {
        return this.originStructs[this.tmplCode];
      },
      orgnizeData() {
        return orgnize(this.struct);
      },
      tmplCodes() {
        let ts = [];
        this.mrs.forEach((m) => {
          if (ts.indexOf(m.tmplCode) < 0) {
            ts.push(m.tmplCode);
          }
        });
        return ts;
      },
      mr() {
        return this.mrs.find((mr) => mr.tmplCode == this.tmplCode);
      },
      pdf() {
        let p = this.pdfs.find((p) => p.code == this.tmplCode);
        if (!p) {
          return null;
        }
        return `${window.location.origin}/api${p.url}`;
      },
    },
    watch: {
      opNo() {
        this.load();
      },
    },
    mounted() {
      api.Setting.query({ sysCode: "emr" })
        .then((res) => {
          let st = res.items.find((i) => i.code == "apiFromHis");
          if (st) {
            this.settingForSimple = JSON.parse(st.value);
            if (this.settingForSimple) {
              this.loadSimple(this.API_SIMPLE);
            }
          }
          st = res.items.find((i) => i.code == "viewDataPriority");
          if (st) {
            this.settingViewDataPriority = st.value;
          }
        })
        .catch((err) => {
          console.log(err);
        });
      this.load();
    },
    methods: {
      load() {
        if (!this.opNo) {
          return;
        }

        this.loading = true;
        api.MrMain.query({ nos: this.opNo })
          .then((res) => {
            if (!res.items.length) {
              throw "nodata";
            }
            this.main = res.items[0];
            api.MrMain.pdf(this.main.id).then((res) => {
              this.pdfs = res.map((item) => JSON.parse(item));
            });
            return api.Mr.query({ mainId: this.main.id });
          })
          .then((res) => {
            this.mrs = res.items;
            if (this.mrs.length) {
              this.view(this.mrs[0].tmplCode);
            } else {
              throw "nodata";
            }
          })
          .catch((err) => {
            if (err == "nodata") {
              if (this.settingForSimple) {
                this.tmplCode = this.API_SIMPLE;
              } else {
                this.errMsg = "抱歉，未找到该患者的病历！";
              }
            } else {
              this.errMsg = err;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      },
      loadSimple(tmplCode) {
        let _this = this;
        this.$set(this.fmtStructs, tmplCode, "加载中...");
        try {
          // let method = this.settingForSimple.method.toLowerCase();
          let url = this.settingForSimple.path.replace("{opNo}", this.opNo);
          swGet(url, {}, this.settingForSimple)
            .then((res) => {
              if (!res.ShuJu || !res.ShuJu.length) {
                throw "无数据";
              }
              // this.$set(this.fmtStructs, tmplCode, res[this.settingForSimple.field]);
              _this.$set(_this.fmtStructs, tmplCode, res.ShuJu[0][_this.settingForSimple.field]);
            })
            .catch((err) => {
              if (err == "无数据") {
                _this.$set(_this.fmtStructs, tmplCode, "调阅失败，简易病历不存在!");
              } else {
                _this.$set(_this.fmtStructs, tmplCode, `调阅失败，${err}`);
              }
              console.log(err);
            });
        } catch (error) {
          _this.$set(_this.fmtStructs, tmplCode, "调阅失败，简易病历接口配置不存在！");
        }
      },
      async view(tmplCode) {
        this.tmplCode = tmplCode;
        this.errMsg = "";
        let txt = this.fmtStructs[this.tmplCode];
        if (txt) {
          if (txt.startsWith("调阅失败")) {
            this.errMsg = txt.substring(5);
          }
          return;
        }
        this.$set(this.fmtStructs, tmplCode, "加载中...");
        this.errMsg = "";
        try {
          this.$utils.log(`查找结构化：${tmplCode} ${this.mr.id}`);
          let sDatas = await api.Struct.query(tmplCode, this.mr.id, 1); // 这里的 1 是数据库版本，不是病历也不是文书版本。数据库版本不同表结构不同（新版保存 MrID 和 MainId。旧版只保存 MainId），表名也不同，原始版本中间没有版本号，新版中间有版本号
          console.log(sDatas);
          if (sDatas && !sDatas.length) {
            sDatas = [sDatas];
          }
          if (!sDatas || !sDatas.length) {
            this.$utils.log(`结构化新版不存在查找旧版：${tmplCode} ${this.main.id}`);
            sDatas = await api.Struct.query(tmplCode, this.main.id);
          }
          if (sDatas && sDatas.length) {
            if (this.settingViewDataPriority == "struct") {
              this.$set(this.fmtStructs, tmplCode, format(sDatas, this.tmplCode) || sDatas[0].allText);
            } else {
              this.$set(this.fmtStructs, tmplCode, sDatas[0].allText || format(sDatas, this.tmplCode));
            }
            this.$set(this.originStructs, tmplCode, sDatas);
            this.view(tmplCode);
          } else {
            this.$utils.log(`未找到结构化：${tmplCode} ${this.main.id}`);
            this.$set(this.fmtStructs, tmplCode, "调阅失败，未找到病历结构化数据！");
          }
        } catch (error) {
          this.$set(this.fmtStructs, tmplCode, `调阅失败，${error}`);
          console.log(error);
        }

        // api.Struct.query(tmplCode, { mrId: this.main.id, dbVer: 1 }).then((res) => {
        //   if (res && res.length) {
        //     if (this.settingViewDataPriority == "struct") {
        //       this.$set(this.fmtStructs, tmplCode,  format(res, this.tmplCode) || res[0].allText);
        //     } else {
        //       this.$set(this.fmtStructs, tmplCode, res[0].allText || format(res, this.tmplCode));
        //     }
        //     this.$set(this.originStructs, tmplCode, res);
        //     this.view(tmplCode)
        //   } else {
        //     api.Struct.query(tmplCode, { mrId: this.main.id }).then((res) => {
        //       if (res && res.length) {
        //         if (this.settingViewDataPriority == "struct") {
        //           this.$set(this.fmtStructs, tmplCode,  format(res, this.tmplCode) || res[0].allText);
        //         } else {
        //           this.$set(this.fmtStructs, tmplCode, res[0].allText || format(res, this.tmplCode));
        //         }
        //         this.$set(this.originStructs, tmplCode, res);
        //       } else {
        //         this.$set(this.fmtStructs, tmplCode, "调阅失败，未找到病历结构化数据！");
        //       }
        //       this.view(tmplCode)
        //     })
        //   }
        // }).finally(() => {
        //   this.loading = false
        // });
      },
    },
  };
</script>
